import { CartesianChart } from '@/common/dashboard/charts/CartesianChart';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

export const ForecastGrossSalesChart = ({ formValues }) => {
  const rsrc = useRsrc();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const { startPeriodId, endPeriodId, brandIds} = formValues;



  useEffect(() => {
    setLoading(true);
    setData(null); // reset so old chart doesn't flash while loading
    const reqParam = { startPeriod: startPeriodId, endPeriod: endPeriodId, brandIds: brandIds };
    rsrc.data('sc', 'FORECAST_SALES_DATA_PLUGIN', reqParam)
      .then((resp) => { setData(resp); })
      .finally(() => { setLoading(false); });
  }, [startPeriodId, endPeriodId, brandIds, rsrc]); // include rsrc to satisfy hooks rule

  if (loading) {
    return (
      <Box sx={{ py: 6, textAlign: 'center' }}>
        <CircularProgress />
        <Typography mt={2}>Loading...</Typography>
      </Box>
    );
  }

  if (!data) return null;

  const brands = Object.keys(data);
  if (!brands.length) return null;

  const periods = Object.keys(data[brands[0]] || {});

  const series = brands.map((brand) => ({
    label: brand,
    values: periods.map((p) => Number(data[brand]?.[p] ?? 0)),
    type: 'line',
  }));

  const chartData = {
    categories: periods,
    series: series,
  }
  return (
    <CartesianChart
      yLabel={'Sales Amount'}
      legend = {'top'}
      data = {chartData}
      
    />
  );
};
